// extracted by mini-css-extract-plugin
export var closeButton = "_21-0";